function PlusIcon() {
  return (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeWidth={2.5} d="M12 5v14M5 12h14" />
    </svg>
  );
}

function MinusIcon() {
  return (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeWidth={2.5} d="M5 12h14" />
    </svg>
  );
}

interface QuantityStepperProps {
  quantity: number;
  onIncrease: () => void;
  onDecrease: () => void;
  disableIncrease?: boolean;
  disableDecrease?: boolean;
  className?: string;
}

export function QuantityStepper({
  quantity,
  onIncrease,
  onDecrease,
  disableIncrease = false,
  disableDecrease = false,
  className = '',
}: QuantityStepperProps) {
  return (
    <div className={`inline-flex items-center border-[1.5px] border-champagne-dark rounded-full ${className}`}>
      <button
        type="button"
        onClick={onDecrease}
        disabled={disableDecrease}
        aria-label="Diminuir quantidade"
        className="w-8 h-8 flex items-center justify-center text-text-dark disabled:opacity-30 disabled:cursor-not-allowed"
      >
        <MinusIcon />
      </button>
      <span className="w-7 text-center text-sm font-bold text-text-dark">{quantity}</span>
      <button
        type="button"
        onClick={onIncrease}
        disabled={disableIncrease}
        aria-label="Aumentar quantidade"
        className="w-8 h-8 flex items-center justify-center text-text-dark disabled:opacity-30 disabled:cursor-not-allowed"
      >
        <PlusIcon />
      </button>
    </div>
  );
}
